import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIcon } from '@icons';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './block-quote.module.scss';
const BlockQuote = ({ children, showInfoIcon = true, size = 'sm', }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const blockQuoteClass = useMemo(() => classNames(styles.block_quote, {
        [styles[`block_quote_${size}`]]: size,
        [styles.dark]: isDarkMode,
    }), []);
    return (_jsxs("div", { className: blockQuoteClass, children: [_jsx("span", { className: styles.block_quote_icon, children: showInfoIcon && _jsx(InfoIcon, {}) }), _jsx("div", { className: styles.block_quote_child_content, children: children })] }));
};
BlockQuote.displayName = 'BlockQuote';
export { BlockQuote };
